import * as React from 'react';
import RadioGroupContext from './RadioGroupContext';
export default function useRadioGroup() {
  return React.useContext(RadioGroupContext);
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/RadioGroup/useRadioGroup.js
// module id = 845
// module chunks = 2